<template>
  <div id="app">
    <AppLayout />

    <svg xmlns="http://www.w3.org/2000/svg" style="display: none;">
        <defs id="svg-sprite">
            <symbol id="slidedown" viewBox="0 0 20 42">
                <path d="M 0.51 0.07 Q 0.51 30.07 13.14 36.39" fill="none" stroke="#000000" stroke-width="2" />
                <path d="M 18.51 39.07 L 9.57 39.07 L 13.14 36.39 L 13.14 31.91 Z" fill="#000000" stroke="#000000" stroke-width="2" />
            </symbol>
            <symbol id="slideup" viewBox="0 0 21 41">
                <path d="M 0.17 39.95 Q 0.17 9.95 12.8 3.63" fill="none" stroke="#000000" stroke-width="2" />
                <path d="M 18.17 0.95 L 12.8 8.11 L 12.8 3.63 L 9.23 0.95 Z" fill="#000000" stroke="#000000" stroke-width="2" />
            </symbol>
            <!-- <symbol id="updown" viewBox="0 0 37 57">
                <path d="M 7.17 47.95 L 17.17 7.95 L 25.17 39.96" fill="none" stroke="#000000" stroke-width="2" />
                <path d="M 26.63 45.78 L 20.81 38.99 L 25.17 39.96 L 28.57 37.05 Z" fill="#000000" stroke="#000000" stroke-width="2" />
            </symbol> -->
            <symbol id="updown" viewBox="0 0 20 42">
                <path d="M 3.87 35.32 L 9.28 4.29 L 13.52 29.34" fill="none" stroke="#000000" stroke-width="2" stroke-miterlimit="10" />
                <path d="M 14.39 33.11 L 11.25 28.28 L 13.52 29.34 L 15.45 27.48 Z" fill="#000000" stroke="#000000" stroke-width="2" stroke-miterlimit="10" />
            </symbol>
            <symbol id="vibration"  viewBox="0 0 24 13">
                <path d="M 0 9.66 Q 1 -6 10 6.5 Q 19 19 22 2" fill="none" stroke="#000000" stroke-width="2" />
            </symbol>
            <!-- <symbol id="arrowup" viewBox="0 0 17 58">
                <path d="M 8 48 L 8 16.19" fill="none" stroke="#000000" stroke-width="2" stroke-miterlimit="10" />
                <path d="M 8 10.19 L 12 18.19 L 8 16.19 L 4 18.19 Z" fill="#000000" stroke="#000000" stroke-width="2" stroke-miterlimit="10" />
            </symbol> -->
            <symbol id="arrowup" viewBox="0 0 20 42">
                <path d="M 9.41 34.76 L 9.41 11.72" fill="none" stroke="#000000" stroke-width="2" stroke-miterlimit="10" />
                <path d="M 9.41 7.38 L 14.12 13.17 L 9.41 11.72 L 4.71 13.17 Z" fill="#000000" stroke="#000000" stroke-width="2" stroke-miterlimit="10" />
            </symbol>
        </defs>
    </svg>


  </div>
</template>

<script>
import AppLayout from './pages/AppLayout.vue';

export default {
  name: 'App',
  components: {
    AppLayout
  }
};
</script>

<style>
@import './assets/global.css'
</style>